import React from 'react'
import styled from 'styled-components'
import { string, func, oneOfType, node, bool, object, array } from 'prop-types'
import { Field, ErrorMessage } from 'formik'
import { TextInput } from './TextInput'
import { StyledLabel, StyledError, ErrorWrapper } from './styles.js'

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.danger};
`

const HelperLabel = styled.span`
  margin-left: auto;
`

const LabelSpan = styled.span`
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
`

export const Input = ({ name, label, helperLabel, component, disabled, ...rest }) => {
  return (
    <>
      <StyledLabel>
        {label && (
          <LabelSpan disabled={disabled}>
            {label}&nbsp;{rest.required && <RequiredSpan>*</RequiredSpan>}
          </LabelSpan>
        )}
        {helperLabel && <HelperLabel>{helperLabel}</HelperLabel>}
        <Field component={component} name={name} disabled={disabled} {...rest} />
      </StyledLabel>
      <ErrorWrapper id='error-wrapper'>
        <ErrorMessage name={name}>{(error) => <StyledError>{error}</StyledError>}</ErrorMessage>
      </ErrorWrapper>
    </>
  )
}

Input.propTypes = {
  name: string.isRequired,
  label: string.isRequired,
  helperLabel: oneOfType([node, string]),
  component: oneOfType([object, func, array, node]),
  disabled: bool,
}

Input.defaultProps = {
  component: TextInput,
}
